import { useLangContext } from "../providers/LangProvider/LangProviderContext.js";
import { NewLifeStyled } from "../modules/NewLife/styled/NewLifeStyled.js";
import { Loader } from "../components/Loader/Loader.jsx";
import { MainHeader } from "../components/main-header/MainHeader.jsx";
import { Button } from "react-bootstrap";
import ProfileButton from "../modules/Account/components/ProfileButton/ProfileButton.jsx";
import { connect } from "react-redux";
import { getNewLifeAccountsAction } from "../modules/Bonus/bonusesActions.js";
import { createStructuredSelector } from "reselect";
import { Link } from "react-router-dom";
import { RouterPaths } from "../app/appConstants.js";
import { getNewLifeAccountsIsLoading } from "../modules/Bonus/bonusesSelectors.js";
import NewLife from "../modules/NewLife/NewLife.jsx";

function NewLifePage(props) {
    const {
        newLifeAccountsIsLoading,
    } = props;

    const {getLangPath} = useLangContext();

    return <NewLifeStyled>

        <Loader show={newLifeAccountsIsLoading}/>
        <MainHeader>
            <Button variant="outline-primary" size="sm" as={Link} to={RouterPaths.trade}>
                {getLangPath('verify.trade')}
            </Button>
            <ProfileButton className="ms-2 ms-sm-3"/>
        </MainHeader>

        {/*Module*/}
        <NewLife/>

    </NewLifeStyled>
}

const mapStateToProps = createStructuredSelector({
    newLifeAccountsIsLoading: getNewLifeAccountsIsLoading,
})

const mapDispatchToProps = (dispatch) => ({
    getNewLifeAccounts: (payload) => dispatch(getNewLifeAccountsAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewLifePage);
